import { StringSchema } from 'yup';
import * as Yup from 'yup';
import { isValidPhoneNumber } from 'libphonenumber-js';

Yup.addMethod<StringSchema>(Yup.string, 'phone', function validatePhone(
  message
) {
  return this.test('test-phone', message, (value) => {
    if (!value) {
      return false;
    }

    return isValidPhoneNumber(value, 'US');
  });
});

declare module 'yup' {
  interface StringSchema {
    phone(message: string): StringSchema;
  }
}
